export class Eligibility {

  constructor(fields) {

    this.fields = fields;
  }

  mapToStandard() {

    return {
      status: this.fields?.status,
      eligibility: this.fields?.eligibility,
      eligibilityRequestId: this.fields?.eligibilityRequestId,
      maxEligibleAmount: this.fields?.maxEligibleAmount?.value,
      offers: this.fields?.offerItems
    };
  }
}